// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"799fc4fe","196":"72c28938","281":"537e1968","394":"d5d70e4f","410":"2fb50cb5","636":"9bf881aa","787":"2136aea4","954":"106fbe2c"}[chunkId] + ".chunk.js";
};